module.exports = __webpack_public_path__ + "img/ic_16_star.05eeac26.svg";